import { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';

import banner_desk from "./assets/imgs/banner_desk.png";
import banner_mob from "./assets/imgs/banner_mob.png";
import banner_praia from "./assets/imgs/banner_praia.jpg";
import valerius360 from "./assets/imgs/valerius360.mp4";

import './App.scss';

function App() {
  const [emailSubscribe, setEmailSubscribe] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleChangeEmailSubscribe = (event) => {
    const input = event.target;
    setEmailSubscribe(input.value);
    setIsButtonDisabled(!input.checkValidity());
  };

  function addEmailSubscribe() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZF91c2VyIjozLCJwYXNzd29yZCI6IiQyYiQxMCRtcDVyNkpISy5nMGtGZ3RYNVNibTJlN2puSTlUVHNsa1JyWVNyRllORWQxbk1VVUxEU3Y5eSIsImNyZWF0ZWRfYXQiOiIyMDI0LTExLTI5VDExOjM1OjM0LjM1MloiLCJyZWZyZXNoX2F0IjoiMjAyNC0xMS0yOVQxMjozNTozNC4zNTJaIiwiZXhwaXJlc19hdCI6IjIwMjQtMTEtMjlUMTI6MzU6MzQuMzUyWiIsInBlcm1pc3Npb25zIjpbeyJpZF9wZXJtaXNzaW9uIjoxLCJkZXNjcmlwdGlvbiI6IlZpZXcgYm9hcmQifV0sImFkbWluIjp0cnVlLCJpYXQiOjE3MzI4ODAxMzR9.DTousFNkZTSTvoRruGr3bvouq3DBwPM6UNBx7iP7Tj4");

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify([{ email: emailSubscribe }])
    };

    fetch('https://swyco-app-prod.azurewebsites.net/api/valerius360', requestOptions)
      .then(async response => {
        if (response.ok) {
          return response.text();
        } else {
          var error = await response.text();
          return Promise.reject({ status: response.status, message: error });
        }
      })
      .then(result => {
        setEmailSubscribe('')
        setIsButtonDisabled(true);
        setOpenSnackbar(true);
      })
      .catch(error => {
      });
  }
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  return (
    <div className="App">
      <div className='w-full h-full'>
        <div className='relative'>
          <div className='w-full h-screen'>
            <video
              autoPlay
              loop
              muted
              playsInline
              loading="lazy"
              rel="preload"
              className="absolute top-0 left-0 w-[100vw] h-[100vh] object-cover z-[-1]"
            >
              <source src={valerius360} type="video/mp4" />
            </video>
            <div className='w-full h-svh flex flex-col justify-between'>
              <div className='p-6 lg:p-14 w-full flex justify-center'>
                <img src="/logo_360.png" width="54px" height="63px" loading="lazy"></img>
              </div>
              <div className='px-6 py-4 lg:px-14 flex flex-col items-center justify-center'>
                <p className='hidden lg:flex text-primary font-regular uppercase'>INTRODUCING</p>
                <p rel="preload" className='text-primary font-rounded-xl uppercase text-center'>THE FUTURE JERSEY SWEATER</p>
              </div>
            </div>
          </div>
        </div>
        <div className='w-full h-auto bg-primary'>
          <div className='w-full flex flex-col lg:flex-row'>
            <div className='w-full lg:w-1/2 flex flex-col p-6 py-12 lg:pr-0 lg:p-12'>
              <div className='md:max-w-[650px] lg:max-w-[550px] text-black font-rounded-base uppercase'>Hi!<br></br>If you are here it’s because you care and want to be part of the change.</div>
            </div>
            <div className='w-full lg:w-1/2 flex flex-col p-6 py-12 pt-0 lg:pl-0 lg:p-12'>
              <div className='md:max-w-[650px] lg:max-w-[550px] flex flex-col justify-center gap-8'>
                <div className='font-regular-base'>360 is evolving to make way for something new. 360 started as a recycling industry in 2017 with the ambition to encourage our brand community to embrace a more circular approach to fashion.<br></br><br></br>We're working on new initiatives for 2025 to extend the life of your brand. Your waste is our solution! We are the future! Please join us. </div>
                <div className='w-full md:max-w-[613px] lg:max-w-[513px] flex flex-col gap-2'>
                  <div className='flex gap-3'>
                    <input type='email' value={emailSubscribe} onChange={handleChangeEmailSubscribe} placeholder='Enter your email' className='w-full rounded-none'></input>
                    <button type="submit" disabled={isButtonDisabled} onClick={() => addEmailSubscribe()} className='w-fit whitespace-nowrap py-2 px-4 bg-black text-primary disabled:opacity-[30%]'>Sign up</button>
                  </div>
                  <label className='text-xs w-[calc(100%_-_110px)]'>By clicking Sign Up you're confirming that you agree with our <a href='https://valerius360.pt/privacy-cookies-policy/' className='underline'>Terms and Conditions</a>.</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='w-full h-auto lg:h-[100dvh] bg-grey'>
          <div className='w-full flex flex-col lg:flex-row'>
            <div className='hidden lg:flex w-full lg:w-1/2 h-[100dvh] items-center justify-center relative'>
              <img src={banner_desk} width="auto" height="auto" className='h-full object-contain object-center' loading="lazy"></img>
            </div>
            <div className='flex lg:hidden w-full lg:w-1/2 relative justify-center'>
              <img src={banner_mob} width="auto" height="auto" className="h-full object-cover object-center"></img>
            </div>
            <div className='w-full lg:w-1/2 flex flex-col justify-center p-6 py-12 lg:p-24 lg:pl-0'>
              <div className='w-full lg:max-w-[550px] flex flex-col justify-center gap-8'>
                <div className='text-black font-rounded-base uppercase'>The Future Jersey Sweater: A Vision For What Fashion Can Be.</div>
                <div className='font-regular-base'>Why the name? Because it’s made from what would’ve been left behind. Every year, 20% of our raw materials go to waste. This sweater is crafted from cotton scraps from our own production. It’s lightweight, soft, and designed for a loose fit that moves effortlessly with you. Here’s the unique part: it’s made with two materials. The sleeves are organic cotton, while the sweater body is recycled cotton.<br></br><br></br>Can you tell the difference? This is the kind of quality we’re proud to create. Step into the future with us.</div>
              </div>
            </div>
          </div>
        </div>
        <div className='w-full h-auto bg-black'>
          <div className='p-6 py-12 lg:p-14 flex flex-col'>
            <div className='text-primary font-rounded-base uppercase'>The facts</div>
            <div className='flex flex-col lg:flex-row gap-5 lg:gap-0 mt-8'>
              <div className='w-full lg:w-1/3 flex flex-row gap-5'>
                <div className='flex lg:hidden text-yellow font-rounded-xl uppercase'>01</div>
                <div>
                  <div className='text-yellow font-rounded-xs uppercase'>The future sweater</div>
                  <div className='text-primary font-regular-xs uppercase'>50% Recycled Cotton<br></br>50% Organic Cotton</div>
                </div>
              </div>
              <div className='w-full lg:w-1/3 flex flex-row gap-5'>
                <div className='flex lg:hidden text-primary font-rounded-xl uppercase'>02</div>
                <div>
                  <div className='text-primary font-rounded-xs uppercase'>Organic sweater</div>
                  <div className='text-primary font-regular-xs uppercase'>100% ORGANIC COTTON</div>
                </div>
              </div>
              <div className='w-full lg:w-1/3 flex flex-row gap-5'>
                <div className='flex lg:hidden text-grey font-rounded-xl uppercase'>03</div>
                <div>
                  <div className='text-grey font-rounded-xs uppercase'>Normal sweater</div>
                  <div className='text-primary font-regular-xs uppercase'>100% CONVENCIONAL COTTON</div>
                </div>
              </div>
            </div>
            <div className='flex lg:hidden flex-row mt-14'>
              <div className='w-1/3'>
                <div className='flex lg:hidden justify-center text-yellow font-rounded-xl uppercase'>01</div>
              </div>
              <div className='w-1/3'>
                <div className='flex lg:hidden justify-center text-primary font-rounded-xl uppercase'>02</div>
              </div>
              <div className='w-1/3'>
                <div className='flex lg:hidden justify-center text-grey font-rounded-xl uppercase'>03</div>
              </div>
            </div>
            <div className='mt-5 lg:mt-10 h-[250px] lg:h-[420px] flex items-end'>
              <div className='w-[calc(33.333333%_-_10px)] h-[3px] lg:h-[5px] bg-yellow'>
              </div>
              <div className='w-[calc(33.333333%_-_10px)] h-[63px] lg:h-[105px] bg-primary'>
              </div>
              <div className='w-[calc(33.333333%_-_10px)] h-[250px] lg:h-[420px] bg-grey'>
              </div>
              <div className='w-[30px] h-full -mb-3 h-[250px] lg:h-[415px] flex flex-col-reverse items-end justify-between'>
                <div className='!text-[0.65em] text-primary font-regular [writing-mode:vertical-lr] rotate-180'>0.00</div>
                <div className='!text-[0.65em] text-primary font-regular [writing-mode:vertical-lr] rotate-180'>0.10</div>
                <div className='!text-[0.65em] text-primary font-regular [writing-mode:vertical-lr] rotate-180'>0.20</div>
                <div className='!text-[0.65em] text-primary font-regular [writing-mode:vertical-lr] rotate-180'>0.30</div>
                <div className='!text-[0.65em] text-primary font-regular [writing-mode:vertical-lr] rotate-180'>0.40</div>
                <div className='!text-[0.65em] text-primary font-regular [writing-mode:vertical-lr] rotate-180'>0.50</div>
                <div className='!text-[0.65em] text-primary font-regular [writing-mode:vertical-lr] rotate-180'>0.60</div>
                <div className='!text-[0.65em] text-primary font-regular [writing-mode:vertical-lr] rotate-180'>0.70</div>
              </div>
            </div>
            <div className='mt-3 w-[calc(100%_-_30px)]'>
              <div className='flex justify-between'>
                <div className='text-primary font-regular-xs'>WATER CONSUMPTION</div>
                <div className='text-primary font-regular-xs'>m<sup>3</sup></div>
              </div>
              <div className='mt-1 w-full h-[1px] bg-primary'></div>
            </div>
            <div className='mt-10 h-[160px] lg:h-[250px] flex items-end'>
              <div className='w-[calc(33.333333%_-_10px)] h-[7.85px] lg:h-[13px] bg-yellow'>
              </div>
              <div className='w-[calc(33.333333%_-_10px)] h-[44px] lg:h-[72px] bg-primary'>
              </div>
              <div className='w-[calc(33.333333%_-_10px)] h-[120px] lg:h-[199px] bg-grey'>
              </div>
              <div className='w-[30px] h-full -mb-3 flex flex-col-reverse items-end justify-between'>
                <div className='!text-[0.65em] text-primary font-regular [writing-mode:vertical-lr] rotate-180'>0.00</div>
                <div className='!text-[0.65em] text-primary font-regular [writing-mode:vertical-lr] rotate-180'>1.00</div>
                <div className='!text-[0.65em] text-primary font-regular [writing-mode:vertical-lr] rotate-180'>2.00</div>
                <div className='!text-[0.65em] text-primary font-regular [writing-mode:vertical-lr] rotate-180'>3.00</div>
              </div>
            </div>
            <div className='mt-3 w-[calc(100%_-_30px)]'>
              <div className='flex justify-between'>
                <div className='text-primary font-regular-xs'>GLOBAL WARMING IMPACT</div>
                <div className='text-primary font-regular-xs'>kg CO<sub>2</sub> eq</div>
              </div>
              <div className='mt-1 w-full h-[1px] bg-primary'></div>
            </div>
          </div>
        </div>
        <div className='w-full h-screen bg-grey bg-cover lg:bg-auto lg:bg-[left_center]' style={{ backgroundImage: `url(${banner_praia})`, backgroundPosition: "-100px center", backgroundRepeat: "no-repeat", filter: "grayscale(1)" }}>
          <div className='w-full flex flex-row'>
            <div className='w-full lg:w-1/2 flex flex-col p-6 py-12 lg:pr-0 lg:p-12'>
              <div className='md:max-w-[650px] lg:max-w-[550px] flex flex-col justify-center gap-8'>
                <div className='text-black font-rounded-base uppercase'>Your Waste Is Our Solution. Join Us.</div>
                <div className='font-regular-base'>Be the first to discover innovative recycling programs and initiatives designed for a sustainable future.</div>
                <div className='w-full md:max-w-[650px] lg:max-w-[513px] flex flex-col gap-2'>
                  <div className='flex gap-3'>
                    <input type='email' value={emailSubscribe} onChange={handleChangeEmailSubscribe} placeholder='Your Email Here' className='w-full rounded-none'></input>
                    <button type="submit" disabled={isButtonDisabled} onClick={() => addEmailSubscribe()} className='w-fit whitespace-nowrap py-2 px-4 bg-black text-primary disabled:opacity-[30%]'>Get Started</button>
                  </div>
                  <label className='text-xs w-[calc(100%_-_110px)]'>By clicking Get Started, you agree to our <a href='https://valerius360.pt/privacy-cookies-policy/' className='underline'>Terms and Conditions</a>.</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <div className='p-6 lg:py-12 relative bg-primary'>
            <div className='footer_logo'>
              <img src="/logo_360.png" width="54px" height="63px" loading="lazy"></img>
            </div>
            <div className='w-full flex flex-col lg:flex-row gap-2 lg:gap-8 justify-center items-center'>
              <div className='text-center lg:text-start'>© 2024 Valérius 360. All rights reserved.</div>
              <a href='https://valerius360.pt/privacy-cookies-policy/' className='underline'>Privacy Policy</a>
              <a href='https://valerius360.pt/privacy-cookies-policy/' className='underline'>Cookie Policy</a>
            </div>
          </div>
        </footer>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={5000}
          onClose={handleClose}
          message="Thanks for joining us."
        />
      </div>
    </div>
  );
}

export default App;